import { useCallback } from 'react'
import log from 'loglevel'
import {
  ListControlTestProcedureVersionsRequest,
  ListControlTestProcedureVersionsResponse,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { ControlServicePromiseClient } from '@trustero/trustero-api-web/lib/model/control_grpc_web_pb'
import { ModelPromiseClient } from '@trustero/trustero-api-web/lib/model/model_grpc_web_pb'
import { NewGrpcResponse, GrpcResponse } from '../../hooks/types'
import { useSwrImmutableGrpc } from '../../useSwrImmutableGrpc'
import { useGrpcRevalidateByMethod } from '../../useGrpcMutate'

export const useControlTestProcedureVersions = (
  controlId?: string,
  shouldFetch = true,
): GrpcResponse<ListControlTestProcedureVersionsResponse> => {
  const request = new ListControlTestProcedureVersionsRequest()
  if (controlId) {
    request.setControlId(controlId)
  }

  const { response } = useSwrImmutableGrpc(
    ControlServicePromiseClient.prototype.listControlTestProcedureVersions,
    request,
    !!controlId && shouldFetch,
  )

  return NewGrpcResponse(response)
}

export const useRefreshAfterTPRSave = (): (() => Promise<void>) => {
  const mutateFunc = useGrpcRevalidateByMethod()
  return useCallback(async () => {
    try {
      await Promise.all([
        mutateFunc(
          ControlServicePromiseClient.prototype.listControlTestProcedureVersions,
        ),
        mutateFunc(ModelPromiseClient.prototype.getControl),
      ])
    } catch (error) {
      log.error('Error refreshing after TPR save', error)
    }
  }, [mutateFunc])
}
